import React  from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup } from 'react-bootstrap'

class RadioGroup extends React.Component {

  handleClick = (child) => {
    if (this.props.onChange  && child.key !== this.props.value) {
      this.props.onChange({ target: { id: this.props.id, value: child.key } })
    }
  }

  renderChildren = () => {
    return React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        checked: (child.key ===  this.props.value),
        onChange: this.handleClick.bind(this, child)
      })
    })
  }

  render() {
    return (
      <ButtonGroup className={this.props.className} bsSize={this.props.bsSize} style={{width: '100%', padding: '6px'}}>
        {this.renderChildren()}
      </ButtonGroup>
    )
  }
}

RadioGroup.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func
}

RadioGroup.defaultProps = {
  onChange: ()=> {},
}

export default RadioGroup



// WEBPACK FOOTER //
// ./src/components/widgets/RadioGroup.js